import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, withCtx as _withCtx, vModelText as _vModelText, withKeys as _withKeys, renderList as _renderList, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a23e79cc")

_pushScopeId("data-v-a23e79cc")
const _hoisted_1 = {
  key: 0,
  class: "card-header border-0 pt-5"
}
const _hoisted_2 = { class: "card-title align-items-center" }
const _hoisted_3 = { class: "svg-icon svg-icon-2 me-2 text-primary" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "card-label fw-bold fs-3" }, "Prospects", -1)
const _hoisted_5 = {
  key: 0,
  class: "alert alert-danger mb-5"
}
const _hoisted_6 = {
  key: 1,
  class: "alert alert-warning mb-5"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" An active AI 24/7 location is required to view prospects. ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Complete setup in the ")
const _hoisted_9 = /*#__PURE__*/_createVNode("strong", null, "Portal", -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" tab.")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Go to AI 24/7")
const _hoisted_12 = { class: "d-flex flex-wrap align-items-center gap-3 mb-4" }
const _hoisted_13 = { class: "d-flex flex-wrap align-items-center gap-2 flex-grow-1" }
const _hoisted_14 = { class: "d-flex flex-wrap align-items-center gap-2" }
const _hoisted_15 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status"
}
const _hoisted_16 = { class: "prospect-inbox d-flex flex-column flex-lg-row" }
const _hoisted_17 = { class: "prospect-inbox__list flex-column flex-lg-row-auto w-100 w-lg-350px w-xl-400px mb-6 mb-lg-0" }
const _hoisted_18 = { class: "card card-flush h-100" }
const _hoisted_19 = { class: "card-header pt-5 pb-3 d-flex align-items-center justify-content-between" }
const _hoisted_20 = /*#__PURE__*/_createVNode("h4", { class: "card-title fw-bold mb-0" }, "Conversations", -1)
const _hoisted_21 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status"
}
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Resume All ")
const _hoisted_23 = { class: "card-body pt-0 px-0" }
const _hoisted_24 = {
  key: 0,
  class: "text-muted text-center py-10 px-4"
}
const _hoisted_25 = {
  key: 1,
  class: "prospect-inbox__list-scroll"
}
const _hoisted_26 = { class: "prospect-inbox__thread flex-lg-row-fluid ms-lg-6" }
const _hoisted_27 = {
  class: "card h-100",
  id: "prospect_inbox_messenger"
}
const _hoisted_28 = {
  class: "card-header align-items-center",
  id: "prospect_inbox_header"
}
const _hoisted_29 = { class: "card-title m-0" }
const _hoisted_30 = { class: "d-flex align-items-start gap-4" }
const _hoisted_31 = { class: "fs-4 fw-bold text-gray-900 mb-1" }
const _hoisted_32 = { class: "d-flex flex-wrap align-items-center gap-2" }
const _hoisted_33 = { class: "text-gray-800" }
const _hoisted_34 = { class: "text-muted fs-7" }
const _hoisted_35 = {
  key: 1,
  class: "badge badge-light-success"
}
const _hoisted_36 = {
  key: 2,
  class: "badge badge-light-warning"
}
const _hoisted_37 = { class: "card-toolbar d-flex flex-wrap gap-2" }
const _hoisted_38 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status"
}
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" Stop AI ")
const _hoisted_40 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status"
}
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" Resume AI ")
const _hoisted_42 = {
  class: "card-body prospect-inbox__messages",
  id: "prospect_inbox_body"
}
const _hoisted_43 = {
  key: 0,
  class: "text-center py-10"
}
const _hoisted_44 = /*#__PURE__*/_createVNode("span", {
  class: "spinner-border spinner-border-sm me-2",
  role: "status"
}, null, -1)
const _hoisted_45 = /*#__PURE__*/_createTextVNode(" Loading messages... ")
const _hoisted_46 = {
  key: 1,
  class: "alert alert-danger mb-0"
}
const _hoisted_47 = {
  key: 2,
  ref: "messagesRef",
  class: "scroll-y pe-2 h-100"
}
const _hoisted_48 = {
  key: 0,
  class: "text-muted text-center py-10"
}
const _hoisted_49 = {
  key: 1,
  ref: "threadEndRef",
  class: "prospect-inbox__thread-end",
  "aria-hidden": "true"
}
const _hoisted_50 = {
  class: "card-footer pt-4",
  id: "prospect_inbox_footer"
}
const _hoisted_51 = {
  key: 0,
  class: "d-flex align-items-center gap-3 mb-3 p-3 rounded bg-light-secondary"
}
const _hoisted_52 = { class: "text-truncate fs-8 fw-semibold flex-grow-1" }
const _hoisted_53 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_54 = { class: "d-flex flex-stack" }
const _hoisted_55 = { class: "d-flex align-items-center gap-2" }
const _hoisted_56 = /*#__PURE__*/_createVNode("i", { class: "bi bi-paperclip fs-3" }, null, -1)
const _hoisted_57 = /*#__PURE__*/_createVNode("span", { class: "text-muted fs-8" }, " Sending a reply or Stop AI pauses AI for this conversation. ", -1)
const _hoisted_58 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status"
}
const _hoisted_59 = /*#__PURE__*/_createTextVNode(" Send ")
const _hoisted_60 = {
  key: 1,
  class: "card-body d-flex align-items-center justify-content-center text-muted py-20"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_router_link = _resolveComponent("router-link")
  const _component_ProspectConversationRow = _resolveComponent("ProspectConversationRow")
  const _component_ContactAvatar = _resolveComponent("ContactAvatar")
  const _component_InboxMessageBubble = _resolveComponent("InboxMessageBubble")

  return (_openBlock(), _createBlock("div", null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 10,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _withDirectives(_createVNode("div", null, [
      _createVNode("div", {
        class: _ctx.embedded ? '' : 'card seq-card mb-5'
      }, [
        (!_ctx.embedded)
          ? (_openBlock(), _createBlock("div", _hoisted_1, [
              _createVNode("h3", _hoisted_2, [
                _createVNode("span", _hoisted_3, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotone/Communication/Address-card.svg" })
                ]),
                _hoisted_4
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", {
          class: _ctx.embedded ? '' : 'card-body py-3'
        }, [
          (_ctx.loadError)
            ? (_openBlock(), _createBlock("div", _hoisted_5, _toDisplayString(_ctx.loadError), 1))
            : _createCommentVNode("", true),
          (!_ctx.hasGhlLocation)
            ? (_openBlock(), _createBlock("div", _hoisted_6, [
                _hoisted_7,
                (_ctx.embedded)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _hoisted_8,
                      _hoisted_9,
                      _hoisted_10
                    ], 64))
                  : (_openBlock(), _createBlock(_component_router_link, {
                      key: 1,
                      to: "/settings/ai247-portal",
                      class: "fw-bold"
                    }, {
                      default: _withId(() => [
                        _hoisted_11
                      ]),
                      _: 1
                    }))
              ]))
            : (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                _createVNode("div", _hoisted_12, [
                  _createVNode("div", _hoisted_13, [
                    _withDirectives(_createVNode("input", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchQuery = $event)),
                      type: "text",
                      class: "form-control form-control-solid",
                      style: {"max-width":"280px"},
                      placeholder: "Search by name",
                      disabled: _ctx.searching || _ctx.syncing,
                      onKeyup: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)), ["enter"]))
                    }, null, 40, ["disabled"]), [
                      [_vModelText, _ctx.searchQuery]
                    ]),
                    _createVNode("button", {
                      type: "button",
                      class: "btn btn-light-primary",
                      disabled: _ctx.searching || _ctx.syncing,
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)))
                    }, _toDisplayString(_ctx.searching ? "Searching..." : "Search"), 9, ["disabled"]),
                    (_ctx.activeSearch)
                      ? (_openBlock(), _createBlock("button", {
                          key: 0,
                          type: "button",
                          class: "btn btn-light",
                          disabled: _ctx.searching || _ctx.syncing,
                          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clearSearch && _ctx.clearSearch(...args)))
                        }, " Clear ", 8, ["disabled"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", _hoisted_14, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.gradeFilters, (option) => {
                      return (_openBlock(), _createBlock("button", {
                        key: option.value,
                        type: "button",
                        class: ["btn btn-sm", _ctx.activeGrade === option.value ? 'btn-primary' : 'btn-light'],
                        disabled: _ctx.searching || _ctx.syncing,
                        onClick: ($event: any) => (_ctx.setGradeFilter(option.value))
                      }, _toDisplayString(option.label), 11, ["disabled", "onClick"]))
                    }), 128))
                  ]),
                  _createVNode("button", {
                    type: "button",
                    class: "btn btn-light",
                    disabled: _ctx.syncing || _ctx.searching,
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.refreshFromCrm && _ctx.refreshFromCrm(...args)))
                  }, [
                    (_ctx.syncing)
                      ? (_openBlock(), _createBlock("span", _hoisted_15))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(_ctx.syncing ? "Syncing..." : "Refresh from CRM"), 1)
                  ], 8, ["disabled"])
                ]),
                _createVNode("div", _hoisted_16, [
                  _createVNode("div", _hoisted_17, [
                    _createVNode("div", _hoisted_18, [
                      _createVNode("div", _hoisted_19, [
                        _hoisted_20,
                        (_ctx.hasPausedConversations)
                          ? (_openBlock(), _createBlock("button", {
                              key: 0,
                              type: "button",
                              class: "btn btn-sm btn-light-primary",
                              disabled: _ctx.resumingAll || Boolean(_ctx.resumingId) || Boolean(_ctx.stoppingId),
                              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.resumeAllAi && _ctx.resumeAllAi(...args)))
                            }, [
                              (_ctx.resumingAll)
                                ? (_openBlock(), _createBlock("span", _hoisted_21))
                                : _createCommentVNode("", true),
                              _hoisted_22
                            ], 8, ["disabled"]))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode("div", _hoisted_23, [
                        (_ctx.prospects.length === 0)
                          ? (_openBlock(), _createBlock("div", _hoisted_24, _toDisplayString(_ctx.emptyStateMessage), 1))
                          : (_openBlock(), _createBlock("div", _hoisted_25, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.prospects, (prospect) => {
                                return (_openBlock(), _createBlock(_component_ProspectConversationRow, {
                                  key: prospect.id,
                                  prospect: prospect,
                                  selected: _ctx.isProspectSelected(prospect),
                                  onSelect: _ctx.selectProspect
                                }, null, 8, ["prospect", "selected", "onSelect"]))
                              }), 128))
                            ]))
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_26, [
                    _createVNode("div", _hoisted_27, [
                      (_ctx.selectedProspect)
                        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                            _createVNode("div", _hoisted_28, [
                              _createVNode("div", _hoisted_29, [
                                _createVNode("div", _hoisted_30, [
                                  _createVNode(_component_ContactAvatar, {
                                    "profile-photo": _ctx.selectedProspect.profilePhoto,
                                    "display-name": _ctx.formatName(_ctx.selectedProspect),
                                    "size-px": 40
                                  }, null, 8, ["profile-photo", "display-name"]),
                                  _createVNode("div", null, [
                                    _createVNode("div", _hoisted_31, _toDisplayString(_ctx.formatName(_ctx.selectedProspect)), 1),
                                    _createVNode("div", _hoisted_32, [
                                      (_ctx.selectedChannelLabel)
                                        ? (_openBlock(), _createBlock("span", {
                                            key: 0,
                                            class: "badge badge-light d-inline-flex align-items-center gap-1",
                                            title: _ctx.selectedChannelLabel
                                          }, [
                                            _createVNode("i", {
                                              class: _ctx.selectedChannelMeta.icon,
                                              style: { color: _ctx.selectedChannelMeta.color }
                                            }, null, 6),
                                            _createVNode("span", _hoisted_33, _toDisplayString(_ctx.selectedChannelLabel), 1)
                                          ], 8, ["title"]))
                                        : _createCommentVNode("", true),
                                      _createVNode("span", {
                                        class: ["badge", _ctx.gradeBadgeClass(_ctx.selectedProspect.leadGrade)]
                                      }, _toDisplayString(_ctx.formatGrade(_ctx.selectedProspect.leadGrade)), 3),
                                      _createVNode("span", _hoisted_34, _toDisplayString(_ctx.selectedProspect.email || _ctx.selectedProspect.phone || "No contact info"), 1),
                                      (_ctx.isAiActive(_ctx.selectedProspect))
                                        ? (_openBlock(), _createBlock("span", _hoisted_35, " AI Active "))
                                        : (_openBlock(), _createBlock("span", _hoisted_36, " Human Handover "))
                                    ])
                                  ])
                                ])
                              ]),
                              _createVNode("div", _hoisted_37, [
                                (_ctx.hasSummary(_ctx.selectedProspect))
                                  ? (_openBlock(), _createBlock("button", {
                                      key: 0,
                                      type: "button",
                                      class: "btn btn-sm btn-light",
                                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showSummary(_ctx.selectedProspect)))
                                    }, " Summary "))
                                  : _createCommentVNode("", true),
                                (_ctx.isAiActive(_ctx.selectedProspect))
                                  ? (_openBlock(), _createBlock("button", {
                                      key: 1,
                                      type: "button",
                                      class: "btn btn-sm btn-light-warning",
                                      disabled: _ctx.stoppingId === _ctx.selectedProspect.id,
                                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.stopAi(_ctx.selectedProspect)))
                                    }, [
                                      (_ctx.stoppingId === _ctx.selectedProspect.id)
                                        ? (_openBlock(), _createBlock("span", _hoisted_38))
                                        : _createCommentVNode("", true),
                                      _hoisted_39
                                    ], 8, ["disabled"]))
                                  : (_openBlock(), _createBlock("button", {
                                      key: 2,
                                      type: "button",
                                      class: "btn btn-sm btn-light-primary",
                                      disabled: _ctx.resumingId === _ctx.selectedProspect.id,
                                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.resumeAi(_ctx.selectedProspect)))
                                    }, [
                                      (_ctx.resumingId === _ctx.selectedProspect.id)
                                        ? (_openBlock(), _createBlock("span", _hoisted_40))
                                        : _createCommentVNode("", true),
                                      _hoisted_41
                                    ], 8, ["disabled"])),
                                (_ctx.locationId && _ctx.selectedProspect.id)
                                  ? (_openBlock(), _createBlock("a", {
                                      key: 3,
                                      href: _ctx.ghlContactUrl(_ctx.selectedProspect) || undefined,
                                      target: "_blank",
                                      rel: "noopener noreferrer",
                                      class: "btn btn-sm btn-light-primary"
                                    }, " Open in CRM ", 8, ["href"]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createVNode("div", _hoisted_42, [
                              (_ctx.threadLoading)
                                ? (_openBlock(), _createBlock("div", _hoisted_43, [
                                    _hoisted_44,
                                    _hoisted_45
                                  ]))
                                : (_ctx.threadError)
                                  ? (_openBlock(), _createBlock("div", _hoisted_46, _toDisplayString(_ctx.threadError), 1))
                                  : (_openBlock(), _createBlock("div", _hoisted_47, [
                                      (_ctx.messages.length === 0)
                                        ? (_openBlock(), _createBlock("div", _hoisted_48, " No messages stored yet. Older AI247 history is not loaded. "))
                                        : _createCommentVNode("", true),
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.messages, (message) => {
                                        return (_openBlock(), _createBlock(_component_InboxMessageBubble, {
                                          key: _ctx.messageKey(message),
                                          message: message,
                                          "contact-name": _ctx.formatName(_ctx.selectedProspect),
                                          onContentLoaded: _ctx.onThreadContentLoaded
                                        }, null, 8, ["message", "contact-name", "onContentLoaded"]))
                                      }), 128)),
                                      (_ctx.messages.length)
                                        ? (_openBlock(), _createBlock("div", _hoisted_49, null, 512))
                                        : _createCommentVNode("", true)
                                    ], 512))
                            ]),
                            _createVNode("div", _hoisted_50, [
                              _createVNode("input", {
                                ref: "attachmentInputRef",
                                type: "file",
                                accept: "image/*,video/*",
                                class: "d-none",
                                disabled: _ctx.sendingMessage || _ctx.uploadingAttachment,
                                onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.handleAttachmentSelected && _ctx.handleAttachmentSelected(...args)))
                              }, null, 40, ["disabled"]),
                              (_ctx.pendingAttachment)
                                ? (_openBlock(), _createBlock("div", _hoisted_51, [
                                    _createVNode("div", _hoisted_52, _toDisplayString(_ctx.pendingAttachment.originalFilename), 1),
                                    _createVNode("span", {
                                      class: ["badge", _ctx.pendingAttachment.status === 'ready' ? 'badge-light-success' : 'badge-light-warning']
                                    }, _toDisplayString(_ctx.pendingAttachment.status), 3),
                                    _createVNode("button", {
                                      type: "button",
                                      class: "btn btn-sm btn-icon btn-light",
                                      disabled: _ctx.sendingMessage || _ctx.uploadingAttachment,
                                      onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.clearAttachment && _ctx.clearAttachment(...args)))
                                    }, [
                                      _hoisted_53
                                    ], 8, ["disabled"])
                                  ]))
                                : _createCommentVNode("", true),
                              _withDirectives(_createVNode("input", {
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.newMessageText = $event)),
                                class: "form-control form-control-flush mb-3",
                                placeholder: "Type a message",
                                disabled: _ctx.sendingMessage,
                                onKeydown: _cache[13] || (_cache[13] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.sendMessage && _ctx.sendMessage(...args)), ["prevent"]), ["enter"]))
                              }, null, 40, ["disabled"]), [
                                [_vModelText, _ctx.newMessageText]
                              ]),
                              _createVNode("div", _hoisted_54, [
                                _createVNode("div", _hoisted_55, [
                                  _createVNode("button", {
                                    type: "button",
                                    class: "btn btn-sm btn-icon btn-active-light-primary",
                                    title: "Attach image or video",
                                    disabled: _ctx.sendingMessage || _ctx.uploadingAttachment,
                                    onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.openAttachmentPicker && _ctx.openAttachmentPicker(...args)))
                                  }, [
                                    _hoisted_56
                                  ], 8, ["disabled"]),
                                  _hoisted_57
                                ]),
                                _createVNode("button", {
                                  type: "button",
                                  class: "btn btn-primary",
                                  disabled: _ctx.sendingMessage || _ctx.uploadingAttachment || !_ctx.canSendMessage,
                                  onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.sendMessage && _ctx.sendMessage(...args)))
                                }, [
                                  (_ctx.sendingMessage || _ctx.uploadingAttachment)
                                    ? (_openBlock(), _createBlock("span", _hoisted_58))
                                    : _createCommentVNode("", true),
                                  _hoisted_59
                                ], 8, ["disabled"])
                              ])
                            ])
                          ], 64))
                        : (_openBlock(), _createBlock("div", _hoisted_60, " Select a conversation to view messages and reply. "))
                    ])
                  ])
                ])
              ], 64))
        ], 2)
      ], 2)
    ], 512), [
      [_vShow, !_ctx.loading]
    ])
  ]))
})